import { put, call, takeLatest, select, delay} from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

function* mailSupportListGet(action) {
  const state = yield select();
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', 'support');
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/mailSupportListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      action.callback(res.data);
      yield put({
        type: "MAIL_GROUP_ITEM_SET",
        payload: {
          type: 'confirmed',
          pic: 'support',
        },
      });
      yield delay(600);
      if (state.notification.mailUnconfirmed > 0) {
        yield put({type: 'NOTIFICATION_GET'});
      }
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

const saga = [
  takeLatest('MAIL_SUPPORT_LIST_GET', mailSupportListGet),
];

export default saga;
